import React from 'react';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import useRouter from '../../hooks/useRouter';
import Urls from '../offer-create/Urls';
import DataCard from '../profile-edit/DataCard';
import usePageRouter from '../../dialogs-routable/_hooks/usePageRouter';

export default function OfferTitle(props) {
  const { offer } = props;
  const { history } = usePageRouter();

  return (
    <DataCard
      title="Title"
      icon={DocumentTextIcon}
      subtitle={offer.data.title || '(not provided)'}
      onClick={() => history.push(Urls(offer).TITLE)}
    />
  );
};
